// Exemplo de uso externo para busca de dados!
// {
//   name: 'nomeDoCliente',
//   type: 'text',
//   placeholder: 'Nome do Cliente',
//   label: 'Nome do Cliente',
//   remote: {
//     method: 'GET',
//     service: 'consulta',
//     path: '/consulta/carteiras',
//   },
//   sizeXs: 12,
//   sizeSm: 6,
//   sizeMd: 4,
//   sizeLg: 3,
// },

const situacaoOptions = [
  {
    text: 'Contrato não recepcionado',
    value: 'Contrato não recepcionado',
  },
  {
    text: 'Protocolo não realizado',
    value: 'Protocolo não realizado',
  },
];

export const tipoDeEnvioOptions = [
  {
    text: 'Principal',
    value: 'principal',
  },
  {
    text: 'Cancelamento com Reposição',
    value: 'cancelamentoComReposicao',
  },
  {
    text: 'Cancelamento sem Reposição',
    value: 'cancelamentoSemReposicao',
  },
  {
    text: 'Complemento ou Regularização',
    value: 'complementoRegularizacao',
  },
  {
    text: 'Devolução de Original',
    value: 'devolucaoOriginal',
  },
  {
    text: 'Devolução via Cliente',
    value: 'devolucaoCliente',
  },
  {
    text: 'Devolução após Preenchimento',
    value: 'devolucaoAposPreenchimento',
  },
  {
    text: 'Troca de Garantia',
    value: 'trocaDeGarantia',
  },
  {
    text: 'Transferência de Dívida',
    value: 'transferenciaDeDivida',
  },
];

const tipoDeProtocoloOptions = [
  {
    text: 'Cancelamento',
    value: 'cancelamento',
  },
  {
    text: 'Reposição',
    value: 'reposição',
  },
];

export const fields = [
  // {
  //   name: 'tipoDeEnvio',
  //   type: 'select',
  //   placeholder: 'Selecione um item',
  //   label: 'Tipo de Envio',
  //   options: tipoDeEnvioOptions,
  //   sizeXs: 12,
  //   sizeSm: 6,
  //   sizeMd: 4,
  //   sizeLg: 3,
  // },
  // {
  //   name: 'tipoDeProtocolo',
  //   type: 'select',
  //   placeholder: 'Selecione um item',
  //   label: 'Tipo de Protocolo',
  //   options: tipoDeProtocoloOptions,
  //   sizeXs: 12,
  //   sizeSm: 6,
  //   sizeMd: 4,
  //   sizeLg: 3,
  // },
  {
    name: 'numeroDoContrato',
    type: 'number',
    placeholder: 'Número do Contrato',
    label: 'Número do Contrato',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 4,
  },
  {
    name: 'cpfCnpj',
    type: 'number',
    placeholder: 'CPF/CNPJ do Cliente',
    label: 'CPF ou CNPJ do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 4,
  },
  {
    name: 'nome',
    type: 'text',
    placeholder: 'Nome do Cliente',
    label: 'Nome do Cliente',
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 4,
  },
  // Teste
  {
    type: 'dateRange',
    name: 'dataBase',
    label: 'Data Base',
    periodoMinimo: '90',
    required: true,
    fields: [
      {
        name: 'dataBaseInicial',
        label: 'Data Base - Início',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 4,
      },
      {
        name: 'dataBaseFim',
        label: 'Data Base - Fim',
        sizeXs: 12,
        sizeSm: 6,
        sizeMd: 4,
        sizeLg: 4,
      },
    ],
  },
  // Fim Teste
  // {
  //   name: 'dataBaseInicio',
  //   type: 'date',
  //   label: 'Data Base - Início',
  //   sizeXs: 12,
  //   sizeSm: 6,
  //   sizeMd: 4,
  //   sizeLg: 3,
  // },
  // {
  //   name: 'dataBaseFim',
  //   type: 'date',
  //   label: 'Data Base - Fim',
  //   sizeXs: 12,
  //   sizeSm: 6,
  //   sizeMd: 4,
  //   sizeLg: 3,
  // },
  // {
  //   name: 'loja',
  //   type: 'select',
  //   placeholder: 'Selecione um item',
  //   label: 'Loja',
  //   options: [
  //   // Aqui tem que fazer uma consulta pra buscar as lojas!
  //     {
  //       text: 'Sim',
  //       value: 'Sim',
  //     },
  //     {
  //       text: 'Não',
  //       value: 'Não',
  //     },
  //   ],
  //   sizeXs: 12,
  //   sizeSm: 6,
  //   sizeMd: 4,
  //   sizeLg: 3,
  // },
  {
    name: 'situacao',
    type: 'select',
    placeholder: 'Selecione um item',
    label: 'Situação',
    options: situacaoOptions,
    sizeXs: 12,
    sizeSm: 6,
    sizeMd: 4,
    sizeLg: 4,
  },
];
